/* BYC 2026-10-25b：最初の画面の文字が画面に入りきらないとき（背の低い画面・スペイン語）、下の※注記を短い版にし、それでも足りなければ少しずつ縮めて収める。
   BYC 2026-10-25：予想価格の目安を予約ページの今の価格（10/24見直し後）に合わせた。下限＝いちばん安いロット、「多くは」＝全ロットの真ん中の半分、1袋＝その幅×30kg。
   BYC 2026-10-19：表記を「2026–27」にそろえ、到着を「2027年 9〜10月」に（「翌年」はいつか分かりにくいため）。
   BYC 2026-10-17：トップの場面を実写ティルトシフトに入れ替えたので、最初の画面に重ねていた地球儀の描画を外した（元のファイルは byc-1014-before1017.js）。
   BYC 2026-10-15：入口の下に、価格の目安・単位・到着・支払いを1行で置く（比べに来た人がすぐ答えを見つけられるように）。
   BYC 2026-10-14：トップの最初の画面に入口を3つ置く（旅を見る／はじめての方へ＝買い方／すぐにロットを選ぶ）。「はじめての方」と書くのは1つだけにして迷わせない。旅が始まるまでは画面下の誘導を隠す */
(function () {
  var hero = document.querySelector('.bycs-ch--hero'), trk = document.querySelector('.bycs-track');
  if (!hero || !trk || hero.querySelector('.bycs-entry')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var box = document.createElement('div');
  box.className = 'bycs-entry';
  var ES = (document.documentElement.lang || '').slice(0, 2) === 'es';  /* 2026-10-19 スペイン語版：html lang が es のときスペイン語 */
  box.innerHTML = ES ? ('<button type="button" class="bycs-go">Baje y vea cómo llega su café desde el origen<i aria-hidden="true"></i></button>' +
    '<a class="bycs-first" href="/es/?view=byc-guide">¿Primera vez?<span class="pc"> (cómo comprar, en 3 minutos)</span></a>' +
    '<a class="bycs-book" href="/es/?view=byc-booking">Elegir ya lotes<span class="pc">&nbsp;2026–27</span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>' +
    '<ul class="bycs-facts" aria-label="Condiciones de reserva">' +
      '<li><small>Precio estimado</small><b>Desde aprox. 2,450 yenes/kg</b><span>La mayoría, 2,620–3,330 yenes/kg; sin impuestos, con costos de importación incluidos</span></li>' +
      '<li><small>Unidad</small><b>Desde 1 saco (30 kg)</b><span>Un saco, aprox. 79,000–100,000 yenes (según el precio estimado)</span></li>' +
      '<li><small>Llegada</small><b>Septiembre–octubre de 2027</b><span>Enviamos saco por saco; también puede guardarlos en una bodega a temperatura constante (que evita que el café verde se deteriore); el almacenaje se cobra al entregar</span></li>' +
      '<li><small>Pago</small><b>Transferencia bancaria al zarpar</b><span>No paga nada al reservar. Se paga por transferencia cuando el barco sale del origen (normalmente en junio–julio). El inventario en Japón también se puede pagar con tarjeta de crédito</span></li>' +
    '</ul>' +
    '<p class="bycs-facts-note"><span class="pc">※El precio estimado se calculó con 1 dólar = 160 yenes. Puede variar según el tipo de cambio y el mercado; el precio final se anuncia en mayo.</span><span class="sp">※Sin impuestos, estimado con 1 dólar = 160 yenes. Precio final en mayo</span></p>') : ('<button type="button" class="bycs-go">スクロールして、産地から届くまでを見る<i aria-hidden="true"></i></button>' +
    '<a class="bycs-first" href="/?view=byc-guide">はじめての方へ<span class="pc">（3分で分かる買い方）</span></a>' +
    '<a class="bycs-book" href="/?view=byc-booking">すぐに<span class="pc">2026–27</span>ロットを選ぶ<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>' +
    '<ul class="bycs-facts" aria-label="ご予約の条件">' +
      '<li><small>予想価格</small><b>1kg 約2,450円〜</b><span>多くは2,620〜3,330円・税抜・輸入費用込み</span></li>' +
      '<li><small>単位</small><b>1袋（30kg）から</b><span>1袋でおよそ7.9万〜10万円（予想価格での目安）</span></li>' +
      '<li><small>到着</small><b>2027年 9〜10月</b><span>1袋ずつ発送、定温倉庫（温度を一定に保ち、生豆の傷みを抑える倉庫）で保管もできます（保管料は納品時にご請求）</span></li>' +
      '<li><small>お支払い</small><b>出港時に銀行振込</b><span>予約の時点では0円。産地から船が出るとき（例年6〜7月）にお振込み・国内在庫はクレジットカードも可</span></li>' +
    '</ul>' +
    '<p class="bycs-facts-note"><span class="pc">※予想価格は1ドル＝160円で計算した目安です。為替や相場によって変わり、確定した価格は5月にお知らせします。</span><span class="sp">※税抜・1ドル＝160円での目安。確定価格は5月にお知らせ</span></p>');
  hero.appendChild(box);
  box.querySelector('.bycs-go').addEventListener('click', function () {
    window.scrollBy({ top: Math.round(window.innerHeight * 0.9), behavior: reduce ? 'auto' : 'smooth' });
  });
  var stg = trk.querySelector('.bycs-stage');
  var upd = function () {
    var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--byc-hh')) || 0;
    if (stg) stg.classList.toggle('byc-started', trk.getBoundingClientRect().top < hh - 4);
  };
  window.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd);
  upd();
  var tst = document.createElement('style');
  tst.textContent = '.bycs-tight .bycs-facts-note .pc{display:none!important}.bycs-tight .bycs-facts-note .sp{display:inline!important}';
  document.head.appendChild(tst);
  var ft = null;
  function over() {
    if (window.innerWidth >= 750) return hero.scrollHeight > hero.clientHeight + 1;
    var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--byc-hh')) || 0;
    return hero.getBoundingClientRect().top < hh + 8;
  }
  function fitHero() {
    hero.classList.remove('bycs-tight'); hero.style.zoom = '';
    if (!over()) return;
    hero.classList.add('bycs-tight');
    for (var z = 0.96; z >= 0.8 && over(); z -= 0.04) hero.style.zoom = z.toFixed(2);
  }
  function fitLater() { clearTimeout(ft); ft = setTimeout(fitHero, 120); }
  fitHero(); window.addEventListener('resize', fitLater); window.addEventListener('load', fitLater);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLater);
  setTimeout(fitHero, 1500);
})();

/* BYC 2026-10-24 社長（スマホ実機の画面写真）：場面の下の文字が画面の下ぎりぎり・切れて見えた。
   スマホでは場面ごとに文字の高さを測り、文字の下に40pxの余白が残るよう、映像の高さを少し低くして文字を上に上げる。
   映像はヘッダーの下に最低160pxは残す。それでも入らない画面では、その場面の本文だけを省く（見出し・数字・リンクは残す）。 */
(function () {
  var root = document.querySelector('[data-bycs]'); if (!root) return;
  var mq = window.matchMedia('(max-width: 749px)'), BOTTOM = 40, GAP = 12, t = null;
  function fit() {
    var stage = root.querySelector('.bycs-stage'); if (!stage) return;
    var scenes = root.querySelectorAll('.bycs-scene + .bycs-scene');
    Array.prototype.forEach.call(scenes, function (s) { s.style.removeProperty('--bycs-vid'); Array.prototype.forEach.call(s.querySelectorAll('.bycs-text'), function (p) { p.style.removeProperty('display'); }); });
    if (!mq.matches) return;
    var H = stage.clientHeight, W = root.clientWidth;
    var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--byc-hh')) || 0;
    var minV = hh + 160, def = Math.min(W * 10 / 9, H - 200);
    Array.prototype.forEach.call(scenes, function (s) {
      var cap = 0; Array.prototype.forEach.call(s.querySelectorAll('.bycs-ch'), function (c) { cap = Math.max(cap, c.offsetHeight); });
      if (!cap) return;
      var v = H - cap - GAP - BOTTOM;
      if (v < minV) {
        Array.prototype.forEach.call(s.querySelectorAll('.bycs-ch .bycs-text'), function (p) { p.style.display = 'none'; });
        cap = 0; Array.prototype.forEach.call(s.querySelectorAll('.bycs-ch'), function (c) { cap = Math.max(cap, c.offsetHeight); });
        v = H - cap - GAP - BOTTOM;
      }
      v = Math.max(minV, Math.min(def, v));
      s.style.setProperty('--bycs-vid', Math.round(v) + 'px');
    });
  }
  function later() { clearTimeout(t); t = setTimeout(fit, 120); }
  fit(); window.addEventListener('resize', later); window.addEventListener('orientationchange', later); window.addEventListener('load', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  setTimeout(fit, 1500);
})();
